import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { ToolbarService, LinkService, ImageService, HtmlEditorService, QuickToolbarService } from '@syncfusion/ej2-angular-richtexteditor';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { ComunidadPublicacionService, ComunidadService, MenuFuncionService } from '../../../../src/app/shared/services';
import { Comunidad, ComunidadPublicacion, DialogConfirmRequest, DialogConfirmResponse, MenuFuncionCodes, SaveComunidadPublicacion, SearchComunidadRequest } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
    selector: 'app-comunidadPublicacionEdit',
    templateUrl: './comunidadPublicacionEdit.component.html',
    styleUrls: ['./comunidadPublicacionEdit.component.scss'],
    providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, QuickToolbarService]
})

export class ComunidadPublicacionEditComponent implements OnInit{

    public tituloTools: object = {
        items: ['Undo', 'Redo', '|',
        'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
        'FontName', 'FontSize', 'FontColor', '|',
        'SubScript', 'SuperScript', '|',
        'LowerCase', 'UpperCase', '|',
        'Formats', 'Alignments', '|', 'CreateLink', '|', 
        'ClearFormat', 'SourceCode'
    ]};
    public tools: object = this.sharedFunctions.getRichTextToolbarItems();
    public insertImageSettings: object = this.sharedFunctions.getRichTextImageSettings
    (
        this.comunidadPublicacionService.getResourceName(),
        this.comunidadPublicacionService.uploadAttachTempUrl()
    );

    formGroup: FormGroup;

    isValidating: boolean = false;
    canEdit: boolean = false;
    canAdd: boolean = false;
    canView: boolean = false;
    canDelete: boolean = false;
    
    comunidadList: Comunidad[];
    isComunidadSearching: boolean;
    isSearchingComunidadNombre: boolean;
    isSearching: boolean;
    isAttachmentSearching: boolean;
    isSaving: boolean;
    isDeleting: boolean;
    isFileAttaching: boolean;

    item: ComunidadPublicacion;
    TituloHtml: any;
    DescripcionHtml: any;
    msgError: string;

    imagenPortadaImageBase64: string | ArrayBuffer | null;
    imagenPortadaImageExtension: string = "";

    constructor(
        private formBuilder: FormBuilder,
        public dialog: MatDialog,
        private sharedFunctions: SharedFunctions,
        private menuService: MenuFuncionService,
        private comunidadService: ComunidadService,
        private location: Location,
        private route: ActivatedRoute,
        private comunidadPublicacionService: ComunidadPublicacionService,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit(): void {
        this.isValidating = true;
        this.menuService.checkMenuPadre(MenuFuncionCodes.COMUNIDAD_PUBLICACIONES).subscribe(data => {
            if (data != null && data.Success && data?.Result) {
                this.isValidating = false;

                this.canEdit = data.Result.some(x => x == MenuFuncionCodes.COMUNIDAD_PUBLICACIONES_EDIT);
                this.canAdd = data.Result.some(x => x == MenuFuncionCodes.COMUNIDAD_PUBLICACIONES_ADD);
                this.canView = data.Result.some(x => x == MenuFuncionCodes.COMUNIDAD_PUBLICACIONES_LIST);
                this.canDelete = data.Result.some(x => x == MenuFuncionCodes.COMUNIDAD_PUBLICACIONES_DELETE);

                this.loadView();
            }
            else {
                this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                this.onCancel();        
            }      
        },
        (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err, true);
        });
    }

    loadView() {
        if (this.canEdit || this.canAdd) {
            this.buildForm();
            this.getComunidades();
        }
        
        this.loadEntity();
    }

    buildForm() {
        this.formGroup = this.formBuilder.group({
            'Titulo': ["", Validators.required],
            'Descripcion': ["", Validators.required],
            'ComunidadId': [null, Validators.required],
            'NotificarUsuarios': [true, Validators.required],
            'Activo': [true]
        });
    }

    getComunidades() {
        var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
        this.isComunidadSearching = true;

        this.comunidadService.search(r).subscribe(data => {
            this.isComunidadSearching = false;
            if(data != null)
                this.comunidadList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isComunidadSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    loadEntity() {
        this.route.params.subscribe(params => {
            if (params['id'] != null && params['id'] != '0') {
                var id = Number(params['id']);
                if (id > 0) {
                    if(this.canView || this.canEdit || this.canAdd){
                        this.isSearching = true;
                        this.comunidadPublicacionService.get(id).subscribe(data => {
                            this.isSearching = false;
                            if (data != null && data.Success) {
                                this.item = data.Result;

                                if (this.item != null && this.item.Id > 0) {
                                    this.loadAttachments(this.item.Id);

                                    if (this.canEdit || this.canAdd) {
                                        this.formGroup.patchValue(this.item);
                                    }
                                    else {
                                        this.TituloHtml = this.sanitizer.bypassSecurityTrustHtml(this.item.Titulo);
                                        this.DescripcionHtml = this.sanitizer.bypassSecurityTrustHtml(this.item.Descripcion);
                                    }
                                }
                                else
                                    this.msgError = "No se encontró la Publicación seleccionada.";
                            }
                            else
                                this.msgError = "Ocurrió un error al intentar obtener los datos de la Publicación.";
                        },
                        (err: HttpErrorResponse) => {
                            this.isSearching = false;
                            this.sharedFunctions.handleError(err, true);
                        })
                    }
                    else {
                        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                        this.onCancel();    
                    }
                }
                else
                    this.msgError = "Item no válido.";
            }
            else {
                if (this.canAdd) {
                    this.item = new ComunidadPublicacion(0, null, null, null, null, null, true, null, []);
                    this.formGroup.patchValue(this.item);
                }
                else {
                    this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                    this.onCancel(); 
                }
            }
        });
    }

    loadAttachments(id: number) {
        this.isAttachmentSearching = true;
        this.comunidadPublicacionService.getAttachments(id).subscribe(data => {
            this.isAttachmentSearching = false;
            if (data != null && data.Success)
                this.item.Adjuntos = data.Result?.filter(f => !f.IncluidoEnCuerpoMensaje);

            if (this.item.Adjuntos == null)
                this.item.Adjuntos = []
        },
        (err: HttpErrorResponse) => {
            this.isAttachmentSearching = false;
            this.sharedFunctions.handleError(err);
        })
    }

    onFileAttachedDelete(item: any) {
        if (item.Id > 0)
          this.onExistingFileAttachedDelete(item);
        else
          this.onNewFileAttachedDelete(item);
    }

    onExistingFileAttachedDelete(item: any) {
        if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
          var index = this.item.Adjuntos.findIndex(f => f.Id == item.Id);
    
          if (index >= 0)
            this.item.Adjuntos.splice(index, 1);
        }
    }

    onNewFileAttachedDelete(item: any) {
        if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
          var index = this.item.Adjuntos.findIndex(f => f.NombreDocumento == item.NombreDocumento);
    
          if (index >= 0)
            this.item.Adjuntos.splice(index, 1);
        }
    }

    onNewFileAttach(event: any) {
        if (event?.target?.files != null && event.target.files.length > 0) {
            var fileList = event.target.files;

            if (this.item.Adjuntos == null)
                this.item.Adjuntos = [];

            for (var i=0; i<fileList.length; i++) {
                if (this.item.Adjuntos.find(f => f.NombreDocumento == fileList[i].name)) {
                    this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
                    return false;
                }
            }

            if (fileList != null && fileList.length > 0) {
                this.isFileAttaching = true;
                this.comunidadPublicacionService.uploadAttachTemp(fileList).subscribe(data => {
                    this.isFileAttaching = false;
                    if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
                        for (let i=0; i<data.Result.Archivos.length; i++) {
                            if (data.Result.Archivos[i] != null) {
                                this.item.Adjuntos.push(data.Result.Archivos[i]);
                            }
                        }
                    }
                    else
                        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
                },
                (err: HttpErrorResponse) => {
                    this.isFileAttaching = false;
                    this.sharedFunctions.handleError(err, true);
                })
            }
        }
    }

    onCancel() {
        this.location.back();
    }

    onGuardar() {
        if (!this.formGroup.valid) {
            this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
            const formGroupcontrols = this.formGroup.controls;
            Object.keys(formGroupcontrols).forEach(controlName => formGroupcontrols[controlName].markAsTouched());
            return false;
        }

        var index = this.imagenPortadaImageBase64?.toString()?.indexOf(",");
        var r = new SaveComunidadPublicacion(0, null, null, null, null, null, null, true, true, []);
    
        if (this.item.Adjuntos == null)
            this.item.Adjuntos = [];
    
        r = {
            ...this.formGroup.value,
            ...{
                Id: (this.item?.Id ?? 0),
                ImagenPortadaBase64: (index != null && index >= 0 ? this.imagenPortadaImageBase64?.toString()?.substring(index + 1) : null),
                ImagenPortadaExtension: this.imagenPortadaImageExtension,
                Activo: (this.item?.Activo ?? true),
                Adjuntos: this.item?.Adjuntos,
            }
        };
    
        this.isSaving = true;
        this.comunidadPublicacionService.save(r).subscribe(data => {
            this.isSaving = false;
            if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
                this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
                this.onCancel();
            }
            else
                this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
            this.isSaving = false;
            this.sharedFunctions.handleError(err, true);
        })
    }

    onDelete() {
        if (!this.canDelete) 
            return false;

        const dialogRef = this.dialog.open(DialogConfirmComponent, {
            data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar la publicación?", null, null)
        });

        dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {

            if (result != null && result.Accepted) {
                this.isDeleting = true;
                this.comunidadPublicacionService.delete(this.item.Id).subscribe(data => {
                    this.isDeleting = false;
                    if (data != null && data.Success && data.Result) {
                        this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
                        this.onCancel();
                    }
                    else
                        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
                },
                (err: HttpErrorResponse) => {
                    this.isDeleting = false;
                    this.sharedFunctions.handleError(err, true);
                })
            }
        });
    }

    isProcessing() {
        return (this.isSearching || this.isSaving || this.isDeleting);
    }

    public tituloImageUploading(args: any): void {
        if (args != null) {
            args.currentRequest.setRequestHeader(
                this.comunidadPublicacionService.getAuthorizationHeaderParameterName(),
                this.comunidadPublicacionService.getAuthorizationHeaderParameterValue()
            );
        }
    }

    public tituloImageUploadSuccess(args: any): void {
        if (args != null && args.file != null) {
            let filename: any = document.querySelectorAll(".e-file-name")[0];
            
            if (filename != null) {
                filename.innerHTML = args.file.name.replace(document.querySelectorAll(".e-file-type")[0].innerHTML, '');
                filename.title = args.file.name;
            }
        }
    }

    public imageUploading(args: any): void {
        if (args != null) {
            args.currentRequest.setRequestHeader(
                this.comunidadPublicacionService.getAuthorizationHeaderParameterName(),
                this.comunidadPublicacionService.getAuthorizationHeaderParameterValue()
            );
        }
    }

    public imageUploadSuccess(args: any): void {
        if (args != null && args.file != null) {
            let filename: any = document.querySelectorAll(".e-file-name")[0];
            
            if (filename != null) {
                filename.innerHTML = args.file.name.replace(document.querySelectorAll(".e-file-type")[0].innerHTML, '');
                filename.title = args.file.name;
            }
        }
    }

//#region FORM ERRORS

    getErrorComunidad() {
        return this.formGroup.get('ComunidadId')?.hasError('required') ? 'El campo es obligatorio' : '';
    }

//#endregion

//#region IMAGEN PERFIL

    imagenPortadaImageChanged() {
        return (this.imagenPortadaImageBase64 != null);
    }

    convertFileToBase64(event) {
        this.imagenPortadaImageBase64 = null;
        const file = event.target.files[0];

        if (file != null) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            // this.backofficeImageBase64 = reader.result;
        };
        reader.onloadend = () => {
            this.imagenPortadaImageBase64 = reader.result;
            this.imagenPortadaImageExtension = (file?.name?.split('.')?.pop() ?? "");
            // console.log(reader.result);
        };
        }
    }

  //#endregion
}